module.exports = __webpack_public_path__ + "img/officeSpace.d6bf440b.png";